(() => {
  const init = () => {
    document.querySelectorAll('.rslr-header__menu-button').forEach((trigger) => {
      if (trigger.dataset.rslrBound) return;
      const menuId = trigger.getAttribute('aria-controls');
      const menu = menuId ? document.getElementById(menuId) : null;
      const panel = menu?.querySelector('.rslr-mobile-menu__panel');
      if (!menu || !panel) return;
      let restoreFocus = false;
      const focusable = () => Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      const setOpen = (open, returnFocus = true) => {
        menu.hidden = !open;
        trigger.setAttribute('aria-expanded', String(open));
        document.documentElement.classList.toggle('rslr-menu-open', open);
        if (open) {
          restoreFocus = true;
          requestAnimationFrame(() => focusable()[0]?.focus());
        } else if (returnFocus && restoreFocus) {
          restoreFocus = false;
          trigger.focus();
        }
      };
      trigger.addEventListener('click', () => setOpen(menu.hidden));
      menu.querySelectorAll('[data-rslr-menu-close]').forEach((element) => element.addEventListener('click', () => setOpen(false)));
      menu.querySelectorAll('a').forEach((element) => element.addEventListener('click', () => setOpen(false, false)));
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false);
          return;
        }
        if (event.key !== 'Tab') return;
        const controls = focusable();
        if (!controls.length) return;
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      trigger.dataset.rslrBound = 'true';
    });
    document.querySelectorAll('.rslr-header__catalog').forEach((details) => {
      if (details.dataset.rslrBound) return;
      document.addEventListener('click', (event) => { if (details.open && !details.contains(event.target)) details.removeAttribute('open'); });
      details.dataset.rslrBound = 'true';
    });
    const path = location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.rslr-header a').forEach((link) => {
      try { const url = new URL(link.href, location.origin); if (url.pathname.replace(/\/$/, '') === path && path !== '') link.classList.add('is-active'); } catch (_) {}
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
